import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ConfirmDlgComponent } from '../discard-change-confirm-dlg/service-center-dialog-confirm.component';
import { FormControl } from '@angular/forms';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';

@Component({
  selector: 'upload-file-dialog',
  templateUrl: './upload-file-dialog.component.html',
  styleUrls: ['./upload-file-dialog.component.scss']
})
export class UploadFileDialogComponent implements OnInit {
  @Input() textBody: string = 'Select a file to import';
  @Input() confirmText: string = 'Select';
  @Input() cancelText: string = 'Cancel';
  @Input() fileTypeAllowed: string = 'pdf, docx, doc, jpeg, jpg, png, xlsx, xls';
  @Input() fileSizeLimit: number = 50 * 1024 * 1024; // 50MB

  fileSelected: File;

  constructor(
    private dialogRef: NbDialogRef<ConfirmDlgComponent>,
    private toastrService: NbToastrService,
  ) {
  }

  ngOnInit() {
  }

  onFileDropped(e) {
    const file = _.get(e, '0');
    if (!this.fileValidationCheck([file])) return;
    this.fileSelected = file;
  }

  fileBrowseHandler(inputFileEvent: HTMLInputElement) {
    const file = _.get(inputFileEvent, 'target.files.0');
    if (!this.fileValidationCheck([file])) return;
    this.fileSelected = file;
  }

  fileValidationCheck(files: File[]): boolean {
    for (let file of files) {
      const fileSize = file.size;
      const extAllowed = this.fileTypeAllowed.split(',').map((ext) => ext.trim());
      const ext = file.name.split('.').pop().toLowerCase();
      // Check file extension and size
      if (extAllowed.includes(ext) && fileSize <= this.fileSizeLimit) {
        return true;
      } else {
        if (fileSize > this.fileSizeLimit) {
          this.toastrService.danger('File size exceeds 50MB.', 'Canceled');
        } else {
          this.toastrService.danger('Please select a supported file format.', 'Canceled');
        }
        return false;
      }
    }
  }

  onSubmit() {
    this.dialogRef.close({
      file: this.fileSelected,
    });
  }

  close() {
    this.dialogRef.close();
  }
}
